enum HeatmapType {
  PLAN = 'plan',
  CAMPAIGN = 'campaign',
}

export default HeatmapType;
